
























// vue
import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class App extends Vue {
  public activeIndex = 0;

  @Prop({
    type: Object,
    required: true,
    default: {},
  })
  public data!: any;

  @Prop({
    type: Object,
    required: true,
    default: {},
  })
  public articleData!: any;

  @Emit('itemClick')
  public emitItemClick(item: any, index: number) {
    this.activeIndex = index;
    return item;
  }
}
